import { useEffect, useRef, useState } from "react";
import { useInView } from "framer-motion";

/**
 * CounterAnimated — increments from 0 to target when scrolled into view.
 */
export const CounterAnimated = ({
  value,
  duration = 2000,
  suffix = "",
  prefix = "",
  className = "",
  format = (n) => Math.floor(n).toLocaleString("fr-FR"),
}) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const [display, setDisplay] = useState(0);

  useEffect(() => {
    if (!inView) return;
    const start = performance.now();
    let raf;
    const tick = (now) => {
      const t = Math.min(1, (now - start) / duration);
      const eased = 1 - Math.pow(1 - t, 3);
      setDisplay(value * eased);
      if (t < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [inView, value, duration]);

  return (
    <span ref={ref} className={className}>
      {prefix}{format(display)}{suffix}
    </span>
  );
};
